import axios from "axios";
import {
  FOLLOW_USER_URL,
  GET_USER_FOLLOWERS_URL,
  GET_USER_FOLLOWING_URL,
  GET_USER_PROFILE_URL,
} from "../constants";

/**
 * Fetches the profile information of a specific user
 * @function getUserProfile
 * @param {string} username Username of profile to fetch
 */
export const getUserProfile = async (username, authToken) => {
  try {
    const response = await axios.get(
      GET_USER_PROFILE_URL(username),
      authToken && { headers: { authorization: authToken } }
    );

    return response.data;
  } catch (err) {
    throw new Error(err);
  }
};

/**
 * Follows or unfollows a user with a given id depending on
 * whether they are already followed
 * @function followUser
 * @param {string} username The username of the user to follow/unfollow
 * @param {string} authToken A user's auth token
 */
export const followUser = async (username, authToken) => {
  try {
    const response = await axios.post(FOLLOW_USER_URL(username), null, {
      headers: { authorization: authToken },
    });
    return response.data;
  } catch (err) {
    throw new Error(err);
  }
};

/**
 * Retrieves who the user is following
 * @function retrieveUserFollowing
 * @param {string} username The username of the user to retrieve following users from
 * @param {string} authToken A user's auth token
 */
export const retrieveUserFollowing = async (username, authToken) => {
  try {
    const response = await axios.get(GET_USER_FOLLOWING_URL(username), {
      headers: { authorization: authToken },
    });
    return response.data;
  } catch (err) {
    throw new Error(err);
  }
};

/**
 * Retrieves who is following the user
 * @function retrieveUserFollowing
 * @param {string} username The username of the user to retrieve followers from
 * @param {string} authToken A user's auth token
 */
export const retrieveUserFollowers = async (username, authToken) => {
  try {
    const response = await axios.get(GET_USER_FOLLOWERS_URL(username), {
      headers: { authorization: authToken },
    });
    return response.data;
  } catch (err) {
    throw new Error(err);
  }
};
